export default "__VITE_ASSET__4e9693a2__"